import { useRef } from 'react';
import { FormApiRef } from '../../components/data/ApiRef';
import DataTable, { ColumnData } from '../../components/data/DataTable';
import DataView from '../../components/data/DataView';
import { EntryPass } from '../../models/Types';
import { isMobile } from '../../utils';
import HouseCombo, { houseStore } from '../houses/HouseCombo';
import { EntryPassForm, entryPassParse } from './EntryPassForm';
import EntryPassList from './EntryPassList';
import { MenuItem, Typography } from '@mui/material';
import { DeleteForeverOutlined } from '@mui/icons-material';

export const columns: ColumnData<EntryPass>[] = [{
    label: 'Рег. номер',
    name: 'CarNumber',
    routerLink: true
}, {
    label: 'Активен до',
    name: 'Expire',
    filter: true,
    type: 'date'
}, {
    label: 'Дом',
    name: 'HouseId',
    store: houseStore,
    filter: (onChange) => <HouseCombo onChange={e => onChange(e.target.value)} />,
    renderer: (val, obj) => houseStore.data?.find(x => x.Id == val)?.Value
}, {
    label: 'Наименование',
    name: 'Name',
    routerLink: true
}, {
    label: 'Марка',
    name: 'CarModel'
},{
    label: 'Цвет',
    name: 'Color',
    filter: true
},];

export default function EntryPassView() {
    const formRef = useRef<FormApiRef>();

    return <DataView<EntryPass>
        menu={isMobile() ? (id) => id ? [<MenuItem onClick={() => formRef.current?.delete()}>
                <Typography color="error" variant="inherit">Удалить пропуск</Typography><DeleteForeverOutlined color="error" />
            </MenuItem>] : undefined : undefined}
        title="Пропуск"
        titleMultiple="Пропуска"
        typeId="EntryPass"
        form={(id, apiRef) => <EntryPassForm key="main" id={id} apiRef={x => { formRef.current = x; apiRef(x); }} />}
        tableRenderer={p => isMobile() ? <EntryPassList {...p} /> : <DataTable<EntryPass> {...p} />}
        tableProps={{ columns, dataParser: entryPassParse }} />;
}